import { createGameCharacter, createGameSession } from '@/types';
export function createSessionForScript(scriptId, scriptName, scriptImageUrl, uiCode, prologue) {
    const stubScript = {
        id: scriptId,
        name: scriptName,
        description: '',
        category: 'remote',
        tags: [],
        author: 'remote',
        version: '1.0.0',
        systemPrompt: '',
        worldDescription: '',
        initialScene: '',
        characterTemplates: [
            {
                id: 'player',
                name: 'Player',
                description: 'Default player character',
                personality: 'neutral',
            },
        ],
        defaultSettings: {},
        createdAt: Date.now(),
        updatedAt: Date.now(),
        playCount: 0,
        config: {
            allowCustomCharacters: true,
            maxPlayers: 1,
            estimatedDuration: 0,
        },
    };
    const character = createGameCharacter(stubScript.characterTemplates[0]);
    const sess = createGameSession(stubScript, character, `${scriptName}`);
    sess.scriptImageUrl = scriptImageUrl;
    if (uiCode && uiCode.trim().length) {
        sess.scriptUiCode = uiCode;
    }
    if (prologue && prologue.trim().length) {
        sess.scriptPrologue = prologue;
    }
    return sess;
}
export function chatToGameMessages(messages) {
    return messages.map((m) => ({
        id: m.id,
        role: m.role,
        content: m.content,
        timestamp: m.timestamp,
    }));
}
